import React from "react";

const leftColumnSections = [
  {
    title: "General Instructions",
    items: [
      "Registration is open exclusively for girl students.",
      "Day 1: 9:00 am to 5:30 pm.",
      "Day 2: 9:00 am to 7:30 pm.",
      "Reporting time: before half an hour on both days.",
    ],
  },
  {
    title: "Dress Code",
    items: [
      "Day 1: Formal business attire such as suits, blazers, ties, formal shirts, trousers, or appropriate formal dresses.",
      "Day 2: Traditional Indian attire such as saree, salwar kameez, or kurta with palazzo/churidar.",
      "Casual clothing such as jeans, T-shirts, sneakers/sports shoes, and excessive accessories is strictly prohibited.",
      "Decent attire is expected throughout the event. Sleeveless, backless, transparent, or otherwise inappropriate clothing is not permitted.",
    ],
  },
  {
    title: "Identity Cards",
    items: [
      "Wearing the official Delegate ID Card is compulsory on both days.",
      "Only the registered delegate carrying a valid ID card will be permitted inside the school campus.",
      "Kindly keep your school ID card ready before completing the registration process.",
    ],
  },
  {
    title: "Mobile Phones & Electronic Devices",
    items: [
      "Mobile phones and electronic devices are permitted solely for academic and conference-related purposes.",
      "Any misuse of devices will invite strict disciplinary action.",
      "Delegates are solely responsible for the safety and security of their personal devices.",
      "Wi-Fi will not be provided.",
    ],
  },
  {
    title: "Damage to Property",
    items: [
      "Any intentional or accidental damage caused to school property, including furniture, fixtures, electronics, or other facilities, shall be the responsibility of the individual(s) concerned.",
      "The cost of repair or replacement, as determined by the management, must be borne by the person(s) responsible.",
    ],
  },
 
  {
    title: "Photography",
    items: [
      "Photography and videography are strictly prohibited during committee sessions unless officially permitted.",
    ],
  },
  {
    title: "Punctuality",
    items: [
      "Delegates must report to the school and all committee sessions according to the official schedule.",
      "The Opening Ceremony will commence promptly at 9:00 a.m. All delegates must report to the Main Hall on time.",
      "Delegates must return punctually after every break. Repeated delays will invite disciplinary action.",
    ],
  },
];

const rightColumnSections = [
  {
    title: "Campus Regulations",
    items: [
      "No unnecessary visits to the school campus before or after the event will be entertained.",
      "Delegates are not permitted to leave the campus during breaks without prior permission.",
    ],
  },
  {
    title: "Registration Process",
    items: [
      "Committee Heads shall complete the registration of their respective delegates.",
      "Delegate kits, placards, and ID cards must be collected and completed with accurate details before committee proceedings begin.",
    ],
  },
  {
    title: "Executive Board Decisions",
    items: [
      "The decision of the Executive Board regarding awards, committee proceedings, and conference matters shall be final and binding.",
    ],
  },
  {
    title: "Social Media Conduct",
    items: [
      "Delegates are expected to use social media responsibly.",
      "Posting misleading, defamatory, or inappropriate content related to the conference, school, organisers, or participants may result in disciplinary action.",
    ],
  },
  {
    title: "Personal Belongings",
    items: [
      "The organisers and the school shall not be responsible for any lost, misplaced, or stolen personal belongings.",
      "Delegates are advised to keep their valuables secure at all times.",
    ],
  },
  {
    title: "Parking",
    items: ["Parking facilities will be provided within the school campus."],
  },
  {
    title: "Submission of Documents",
    items: [
      "Upload only clear and legible photographs and documents wherever required.",
    ],
  },
  {
    title: "Conference Guidelines",
    items: [
      "Delegates are expected to read, understand, and comply with the official Code of Conduct.",
      "Regularly visit the official conference website for updates, announcements, and additional guidelines.",
    ],
  },
   {
    title: "Professional Conduct",
    items: [
      "Delegates must maintain professionalism, discipline, and respect towards all participants, Executive Board members, teachers, staff, and guests throughout the conference.",
      "Disruptive behaviour, harassment, verbal abuse, physical altercations, or any form of misconduct will not be tolerated.",
      "Serious violations may result in immediate removal from the conference, disqualification, prohibition from future editions, and, where applicable, legal action.",
    ],
  },
];

const MunDelegatesInst = () => {
  const SectionCard = ({ section }) => (
    <div className="mun-guide-card">
      <div className="mun-guide-card__head">
        <h5>{section.title}</h5>
      </div>
      <ul className="mun-guide-list">
        {section.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </div>
  );

  return (
    <div className="row g-4 mun-delegates-inst mun-principal-invitation">
      <div className="col-lg-6 col-md-12 col-sm-12 col-12">
        <div className="mun-guide-column ">
          {leftColumnSections.map((section) => (
            <SectionCard key={section.title} section={section} />
          ))}
        </div>
      </div>
      <div className="col-lg-6 col-md-12 col-sm-12 col-12">
        <div className="mun-guide-column ">
          {rightColumnSections.map((section) => (
            <SectionCard key={section.title} section={section} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MunDelegatesInst;
